export default function RecentPost(){

    const hotelImages = [
        {
          place: "img/keyword-image/best-luxury-pg-in-pune.jpg",
          text: "Best Luxury PG in Pune",
          path:'Best-Luxury-PG-in-Pune'
        },
        {
          place: "img/keyword-image/Best-pg-in-kharadi.jpg",
          text: "Best PG In Kharadi",
          path:'PG-in-Kharadi'
        },
        {
          place: "img/keyword-image/Monthly-basis-pg-in-kharadi.jpg",
          text: "Monthly Basis PG in Kharadi",
          path:'Monthly-Basis-PG-in-Kharadi'
        },
        {
          place: "img/keyword-image/Kharadi-IT-park-near-pune.jpg",
          text: "Paying Guest Near Kharadi IT Park Pune",
          path:'Paying-Guest-Near-Kharadi-IT-Park-Pune'
        },
        {
          place: "img/keyword-image/paying-guest-hostel-in-chandan-nagar.jpg",
          text: "Paying Guest Hostel in Chandan Nagar",
          path:'Paying-Guest-Hostel-in-Chandan-Nagar'
        },
        {
          place: "img/keyword-image/pg-in-kharad-with-food.jpg",
          text: "PG in Kharadi With Food",
          path:'PG-in-Kharadi-With-Food'
        },
        {
          place: "img/keyword-image/pg-for-working-professionals.jpg",
          text: "PG for Working Professionals Pune",
          path:'PG-for-Working-Professionals-Pune'
        },
        {
          place: "img/keyword-image/wadgoan-sheri-pg.jpg",
          text: "Wadgaon Sheri PG",
          path:'Wadgaon-Sheri-PG'
        }
    
      
      ];
    return(
        <>
        <div className="col-12 col-md-4">
            <h2>Recent Post</h2>
              {hotelImages.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href={e.path}
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href={e.path} className="recent-text">{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}

            <div className="contact-box-keyword">
                <h5 className="pb-3 pt-3 text-recent">Contact Information</h5>

                <div className="services__two-item">
                  <div className="mybox1 text-center p-3 mb-3">
                    <a href="tel:+91 9763888448">
                      <i class="bi bi-telephone-fill fs-1 text-white"></i>
                      <div>
                        <a href="tel:+91 9763888448" className="text-white">+91 9763888448</a>
                      </div>
                    </a>

                    <a href="tel:+91 9922248255">
                      {/* <i class="bi bi-telephone-fill fs-1"></i> */}
                      <div>
                        <a href="tel:+91 9922248255"  className="text-white">+91 9922248255</a>
                      </div>
                    </a>
                  </div>

                  <div className="mybox1 text-center p-3 mb-3">
                    <a href="  mailto:omsaipgpune@gmail.com">
                      <i class="bi bi-envelope fs-1 text-white"></i>
                      <div className="text-white">
                        <a href="  mailto:omsaipgpune@gmail.com"  className="text-white">
                        omsaipgpune@gmail.com
                  </a>
                      </div>
                    </a>
                  </div>

                  <div className="mybox1 text-center p-3 mb-3">
                  <a href="/" className="text-white">
                    <i class="bi bi-house-fill fs-1"></i>
                    <p  className="text-white">
                    Tulja Bhavani Nagar- lean no 7 <br/> Near Durga Mata Mandir,<br/> kharadi Pune - 411014
                    </p>
                  </a>
                </div>
            </div>
        </div>
        </div>
        
        </>
    )
}